// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import searchMdIcon from "@/assets/icons/search-md.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type SearchMdIconProps = Omit<IconProps, "name">;

export function SearchMdIcon(props: SearchMdIconProps): React.ReactNode {
  return <Icon name={searchMdIcon} {...props} />;
}
